import { toast } from 'react-toastify'
import { axiosInstance as axios } from '../lib/axios'
import Config from '../config/environments'
import { localRemove } from '../lib/session'
import { DEFAULT_STORE, LIST_BRANCH, IS_IPP, CLEAR_BRANCH } from '../actionTypes/branch'
import { viewsModelToModels } from '../mapper/branch'
import { updateState } from '.'
import history from '../service/history'

export const getDataBranch = (document) => async (dispatch, getState) => {
  const base = {
    type: LIST_BRANCH,
    payload: {},
    state: true
  }

  let url = Config.STORE.BRANCH

  const {
    userState: { authUser }
  } = getState()

  if (authUser.readOnly || document) {
    url = `${Config.STORE.BACKOFFICE_BRANCHES}/${document}`
  }

  axios
    .get(url)
    .then((response) => {
      base.payload = updateState(response)
      base.payload.data = viewsModelToModels(base.payload.data)

      // Sem filiais (ex.: 204 sem corpo no /backoffice/store/branches/{cnpj}
      // ou lista vazia): 2xx não passa pelo toast do lib/validation.js, então
      // avisa aqui antes de voltar para a busca — senão o retorno é silencioso.
      // data fica null (mesmo valor do legado) para as telas pularem a lista
      const hasBranches = Array.isArray(base.payload.data) && base.payload.data.length > 0
      if (!hasBranches) {
        base.payload.data = null
      }

      const isIPP = hasBranches && base.payload.data[0].IPP ? true : false
      dispatch({
        type: IS_IPP,
        payload: { state: false, isIPP },
        state: true
      })

      if (!hasBranches) {
        toast.error('Este posto não possui filiais cadastradas. Selecione outro posto.')
        history.goBack()
      }
    })
    .catch((error) => {
      base.payload = error
    })
    .finally(() => {
      dispatch(base)
    })

  dispatch(base)
}

export const setDefaultStore = (data) => async (dispatch) => {
  dispatch({
    type: DEFAULT_STORE,
    payload: { state: false, data },
    state: true
  })

  if (!data) localRemove('STORES')
}

export const clearBranch = () => async (dispatch) => {
  dispatch({
    type: CLEAR_BRANCH,
    payload: null,
    state: false
  })
}
